<template lang="html">
  <el-row>
    <el-col >
      <el-row :class="[qdata.achievement==0?'bg-eee':'bg-err', 'pd-tb10', 'pd-lr10', 'border-radio10']">
        <div class="title">
          <slot name="order"></slot><span v-html="qdata.question"></span>
        </div>
        <div class="option">
          <ul>
            <li :class="[qdata.answer=='0'?'activer':'']">√正确</li>
            <li :class="[qdata.answer=='1'?'activer':'']">×错误</li>
          </ul>
        </div>
        <div class="awser">
          考生选择答案：{{qdata.rightAnswer | answer}}
        </div>
        <div class="analysis">
          解析：{{qdata.remark}}
        </div>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Judgeac',
  props:['qdata'],
  data(){
    return {
      radio:'1'
    }
  },
  created(){
    console.log(this.qdata);
  },
  filters:{
    answer(val){
      if(val==''){
        return '考生未作答'
      }
      return val == 0?"正确":"错误"
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.bg-err{
  background: rgba(255, 0, 0, 0.15);
}
.awser,.analysis{
  font-size: 14px;
  padding-bottom: 10px;
  padding-left: 5px;
  color: #666;
}
.option{
  font-size: 14px;
  margin: 15px 5px;
  li{
    padding: 10px 0;
     span{
      line-height: 16px;
    }
  }
  li.activer{
    color: #409EFF;
  }

}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
